import { CYBER } from 'containers/Cyber/constantes/general';
import { LF } from 'containers/LineasFinancieras/Constantes/general';
import useCustomRouter from 'hooks/useCustomRouter';
import useQueryParams from 'hooks/useQueryParams';
import { useMemo } from 'react';
import PRODUCTOS from 'utils/constants/PRODUCTOS';
import { getBreadCrumb } from './constants/breadcrumbs';

/**
 *
 * @param {string} ramo
 * @returns {{personaFisicaHabilitado:boolean,personaMoralHabilitado:boolean}}
 */
const mapFigurasHabilitadas = (ramo) => {
  switch (ramo) {
    case PRODUCTOS.HOGAR:
    case PRODUCTOS.HOGAR_DTC:
    case PRODUCTOS.RCPA:
    case PRODUCTOS.lnPresRcpa:
      return {
        personaFisicaHabilitado: true,
        personaMoralHabilitado: false,
      };

    case PRODUCTOS.CYBER:
    case PRODUCTOS.DO:
      return {
        personaFisicaHabilitado: false,
        personaMoralHabilitado: true,
      };
    default:
      return {
        personaFisicaHabilitado: true,
        personaMoralHabilitado: true,
      };
  }
};

const mapRoutes = (ramo) => {
  switch (ramo) {
    case 'AUTO':
      return {
        Next: (routeProps) =>
          `/emision-contratante?idPoliza=${routeProps.idPoliza}&codProducto=${ramo}`,
        Back: (routeProps) =>
          `/riesgo-auto-conductor?idPoliza=${routeProps.idPoliza}&codProducto=${ramo}`,
      };

    case 'APINDIVIDUAL':
      return {
        Next: (routeProps) =>
          `/emision-contratante?idPoliza=${routeProps.idPoliza}&codProducto=${ramo}`,
        Back: (routeProps) => `/accidentes-resumen-personas/${routeProps.idCotizacion}`,
      };

    case 'lnPresRcpa':
    case 'RCPA':
      return {
        Next: (routeProps) =>
          `/rcpa-cliente?idPoliza=${routeProps.idPoliza}&codProducto=${LF.prodCodigoCore}`,
        Back: (routeProps) => `/rcpa-resumen?idCotizacion=${routeProps.idCotizacion}`,
      };

    case 'lnPresRcp':
    case 'RCP':
      return {
        Next: (routeProps) => `/rcp-cliente?idPoliza=${routeProps.idPoliza}&codProducto=${ramo}`,
        Back: (routeProps) => `/rcp-resumen?idCotizacion=${routeProps.idCotizacion}`,
      };

    case 'lnPresCyber':
    case 'CYBER':
      return {
        Next: (routeProps) =>
          `/cyber-cliente?idPoliza=${routeProps.idPoliza}&codProducto=${CYBER.codProducto}`,
        Back: (routeProps) => `/cyber-resumen?idCotizacion=${routeProps.idCotizacion}`,
      };

    case 'lnPresDO':
      return {
        Next: (routeProps) => `/do-cliente?idPoliza=${routeProps.idPoliza}&codProducto=${ramo}`,
        Back: (routeProps) => `/do-resumen?idCotizacion=${routeProps.idCotizacion}`,
      };

    case 'MARINEINLAND':
      return {
        Next: (routeProps) =>
          `/marine-emision-contratante?idPoliza=${routeProps.idPoliza}&codProducto=${ramo}`,
        Back: (routeProps) =>
          `/marine-infoequipos?idPoliza=${routeProps.idPoliza}&codProducto=${ramo}`,
      };

    case 'CASUALTYCONTRATISTAS':
      return {
        Next: (routeProps) =>
          `/casuality/emision-contratante?id=${routeProps.idPoliza}&codProducto=${ramo}`,
        Back: (routeProps) => `/casuality/resumen?id=${routeProps.idCotizacion}`,
      };

    case 'CASUALTYGENERALES':
      return {
        Next: (routeProps) =>
          `/casuality/generales/emision-contratante?id=${routeProps.idPoliza}&codProducto=${ramo}`,
        Back: (routeProps) => `/casuality/generales/resumen?id=${routeProps.idCotizacion}`,
      };

    case 'pymesCerradoInd':
      return {
        Next: (routeProps) =>
          `/presuscrito-contratante?idPoliza=${routeProps.idPoliza}&codProducto=pymesCerradoInd`,
        Back: (routeProps) => `/presuscrito-resumen?idCotizacion=${routeProps.idCotizacion}`,
      };

    case 'pymesAbiertoInd':
      return {
        Next: (routeProps) => `/pymes-emision-contratante/${routeProps.idPoliza}`,
        Back: (routeProps) => `/pymes5/${routeProps.idCotizacion}`,
      };

    case 'hogarCotizadorFlex':
      return {
        Next: (routeProps) =>
          `/hogar-emision-contratante?idPoliza=${routeProps.idPoliza}&codProducto=hogarCotizadorFlex&ramo=hogarCotizadorFlex`,
        Back: (routeProps) => `/hogar3/${routeProps.idCotizacion}`,
      };

    case 'HOGAR':
    case 'hogarCotizadorDTC':
      return {
        Next: (routeProps) =>
          `/hogar-emision-contratante?idPoliza=${routeProps.idPoliza}&codProducto=HOGAR&ramo=hogarCotizadorDTC`,
        Back: (routeProps) => `/hogar3/${routeProps.idCotizacion}`,
      };

    case 'SKT':
      return {
        Next: (routeProps) => `/kids/pagador?idPoliza=${routeProps.idPoliza}&codProducto=SKT`,
        Back: (routeProps) => `/kids/pago?idCotizacion=${routeProps.idCotizacion}`,
      };

    default:
      break;
  }
};
const useFormularioFacturacionConfig = () => {
  const { idPoliza, ramo, codProducto } = useQueryParams();

  const history = useCustomRouter();

  const breadCrumb = useMemo(() => {
    if (codProducto) {
      return getBreadCrumb(codProducto);
    }

    if (ramo) {
      return getBreadCrumb(ramo);
    }
    return null;
  }, [ramo, codProducto]);

  const { Next, Back } = useMemo(() => {
    if (codProducto) {
      return mapRoutes(codProducto);
    }

    if (ramo) {
      return mapRoutes(ramo);
    }

    return {
      Next: () => {
        console.log('Not implemented');
      },
      Back: () => {
        console.log('Not implemented');
      },
    };
  }, [ramo, codProducto]);

  const figurasHabilitadas = useMemo(() => {
    if (codProducto) {
      return mapFigurasHabilitadas(codProducto);
    }

    if (ramo) {
      return mapFigurasHabilitadas(ramo);
    }
    return {
      personaFisicaHabilitado: true,
      personaMoralHabilitado: true,
    };
  }, [ramo, codProducto]);

  return {
    idPoliza,
    ramo,
    Next,
    Back,
    breadCrumb,
    history,
    figurasHabilitadas,
  };
};

export default useFormularioFacturacionConfig;
